<ion-grid [hidden]="scanCamera">
    <ion-row class="ion-justify-content-center" style="height:450px;">
        <ion-col class="ion-align-self-center" size-md="6" size-lg="5" size-xs="12" class="outer">
            <div class="ion-text-center">
                <h4>Lisaas login</h4>
            </div>
            <div *ngIf="firstTime && autoLoginEnabled && autoLogin">Auto login poging ...</div>
            <ng-container *ngIf="!(firstTime && autoLoginEnabled && autoLogin)">
                <div class="ion-padding">
                    <ion-grid>
                        <ion-row>
                            <ion-col>
                                <ion-item>
                                    <ion-input type="text" placeholder="Company" #inpCmpFld [(ngModel)]="inpCompany"></ion-input>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <ion-item>
                                    <ion-input type="text" placeholder="Username" #inpUsrFld [(ngModel)]="inpUsr"
                                        (keyup.enter)="pwdBlur()" (ionBlur)="pwdBlur()" [autofocus]="true"
                                        autocomplete="username"></ion-input>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                        <ion-row style="align-items: center;">
                            <ion-col>
                                <ion-item>
                                    <ion-input [type]="showpwd ? 'text' : 'password'" #inpPwdFld placeholder='Password' [(ngModel)]='inpPwd'
                                        (click)="inpPwd=''" (keyup.enter)="login()" (ionBlur)="pwdBlur()"
                                        autocomplete="current-password"></ion-input>
                                    </ion-item>
                                </ion-col>
                            <ion-col size="auto">
                                <ion-icon [name]="showpwd ? 'eye-off-outline' : 'eye-outline'" (click)="showpwd=!showpwd" (keyup.enter)="login()"></ion-icon>
                            </ion-col>
                        </ion-row>
                        <ion-row *ngIf="autoLoginEnabled">
                            <ion-col>
                                <ion-item>
                                    <ion-checkbox labelPlacement="end" justify="start"
                                        [(ngModel)]="autoLogin"
                                    >
                                        Automatisch inloggen
                                    </ion-checkbox>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </div>
                <div class="ion-padding" *ngIf="!wait">
                    <ion-button type='submit' size="large" expand="block" (click)="login()">Login</ion-button>
                </div>
            </ng-container>
            <div class="ion-padding" *ngIf="wait">
                <mat-spinner diameter="50"></mat-spinner>
            </div>

            <ion-item *ngIf="errmsg">{{errmsg}}</ion-item>
            <ion-item>
                v.{{global.Version}}
                &nbsp;
                <a href='{{global.apkurl}}' *ngIf="global.apkDownload && (global.latestVersion > global.Version)">Update beschikbaar</a>
            </ion-item>
        </ion-col>
    </ion-row>
</ion-grid>
<ion-fab vertical="bottom" horizontal="end" slot="fixed" [hidden]="scanCamera">
    <ion-fab-button (click)="doScan()" *ngIf="!global.optHideScanBtn">
        <ion-icon name="barcode"></ion-icon>
    </ion-fab-button>
</ion-fab>
